export default "__VITE_ASSET__CI7bvuQv__"